import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import TextareaAutosize from '@fulcrumapp/react-textarea-autosize';
import TextElementView from './text-element-view';

export default class CalculatedElementView extends TextElementView {
  renderEditable() {
    // @ts-ignore
    const textElementStyles = TextElementView.styles;
    // @ts-ignore
    const { styles } = CalculatedElementView;

    return (
      <TextareaAutosize
        useCacheForDOMMeasurements
        minRows={1}
        value={this.inputValue}
        onChange={this.handleChange}
        className={css(textElementStyles.default, styles.default)}
        disabled
      />
    );
  }

  get inputValue() {
    // @ts-ignore
    return this.props.value.displayValue || '';
  }
}
// @ts-ignore
const styles = cssInJS({
  default: {
    backgroundColor: '#eee',
    cursor: 'not-allowed',
  },
});
// @ts-ignore
CalculatedElementView.styles = styles;
